import { render, staticRenderFns } from "./VideoTutorials.component.vue?vue&type=template&id=2ad3a370&scoped=true&"
import script from "./VideoTutorials.component.vue?vue&type=script&lang=js&"
export * from "./VideoTutorials.component.vue?vue&type=script&lang=js&"
import style0 from "./VideoTutorials.component.vue?vue&type=style&index=0&id=2ad3a370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad3a370",
  null
  
)

export default component.exports